import $ from 'jquery';
import 'arrive';

$(document).ready(function () {
    document.arrive('.srg-custom-select', {existing: true}, function () {
        initSrgCustomSelects($(this));
    });
});

function initSrgCustomSelects($el) {
    $el.find('select').each(function () {
        let $this = $(this),
            numberOfOptions = $(this).children('option').length;

        $this.after('<div class="srg-custom-select-styled"></div>');
        let $styledSelect = $this.next('div.srg-custom-select-styled');

        // Show the first select option in the styled div
        $styledSelect.text($this.children('option').eq(0).text());

        // Insert an unordered list after the styled div and also cache the list
        let $list = $('<ul />', {
            'class': 'srg-custom-select-options'
        }).insertAfter($styledSelect);

        // Insert a list item into the unordered list for each select option
        for (let i = 0; i < numberOfOptions; i++) {
            $('<li />', {
                text: $this.children('option').eq(i).text(),
                rel: $this.children('option').eq(i).val()
            }).appendTo($list);
        }

        let $resetFilter = $('<span />', {
            'class': 'reset-filter'
        }).insertAfter($list);

        // Cache the list items
        let $listItems = $list.children('li');

        $resetFilter.click(function (e) {
            e.stopPropagation();
            $list.children('li[rel="0"]').click();
            $list.children('li[rel="-1"]').click();
        });

        // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
        $styledSelect.click(function (e) {
            e.stopPropagation();
            let opening = !$(this).hasClass('active');
            $('div.srg-custom-select-styled.active').each(function () {
                $(this).removeClass('active');
            });
            if (opening) {
                $(this).addClass('active');
            }
        });

        // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
        // Updates the select element to have the value of the equivalent option
        $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            let rel = $(this).attr('rel');
            $this.val(rel).change();
            if (rel == 0 || rel == -1) {
                $styledSelect.removeClass('resettable');
            } else {
                $styledSelect.addClass('resettable');
            }
        });

        // Hides the unordered list when clicking outside of it
        $(document).click(function () {
            $styledSelect.removeClass('active');
        });

    });
}